// Lives in its own file (not inline in auditFeature.ts) so the route factory
// can import it without a circular import back through
// auditFeature.ts -> presentation/routes -> here.
// Irregular: audit only ever grants view.
export const AUDIT_LOG_VIEW = "core.audit_management.audit_log_list.view";
